var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#326297",
    d: "M33.46 17.727a2.96 2.96 0 1 1-5.921.001 2.96 2.96 0 0 1 5.921 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#326297",
    d: "M30.5 3c14.887 0 27 12.112 27 26.999 0 14.887-12.113 27-27 27S3.5 44.888 3.5 30c0-14.888 12.112-27 27-27Zm0-3C13.932 0 .5 13.431.5 30c0 16.568 13.431 30 30 30 16.568 0 30-13.431 30-30 0-16.568-13.432-30-30-30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#326297",
    d: "M28.4 24.727h4.2v20.507h-4.2V24.727Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoPrimary);
export default __webpack_public_path__ + "static/media/icon-info-primary.c6553fa1260eeee86af78d8e822eb405.svg";
export { ForwardRef as ReactComponent };